// extracted by mini-css-extract-plugin
export default {"sigContainer":"styles_sigContainer__R093z","sigPad":"styles_sigPad__+2ssK","signButtons":"styles_signButtons__rKCIR","sigImage":"styles_sigImage__mfEfp"};